import { render, staticRenderFns } from "./MagazineTable.vue?vue&type=template&id=127c02a3&"
import script from "./MagazineTable.vue?vue&type=script&lang=js&"
export * from "./MagazineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports